// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"98c52ee14c229560","6831":"a8aa2a5f71737989","8503":"b6a2d850973d4484","9683":"5b7aece501e8a4f4"}[chunkId] + ".js";
};